module.exports = __webpack_public_path__ + "static/img/ganzhiyu.94fe6dbc.png";